import { ArrowBack } from "@mui/icons-material";
import { Button, ButtonGroup, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { BrandEnum } from "../../../_common/enum/brand.enum";
import { FormTemplateTypeEnum } from "../../../_common/enum/forms/formTemplateType.enum";
import { splitWordOnCamelCase } from "../../../_helpers/format.helper";
import { formService } from "../../../_services/form.service";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { retryHeight, sendContainerHeightToParent } from "../../../_helpers/iFrameSize.helper";
import { quoteTypeOrder } from "../../../_const/quoteTypeDisplayOrder.const";
import { withFormAccessToken } from "../../../_helpers/formAccessToken.helper";

export function MortgagesHeader(params: {
    formId?: string,
    brand: BrandEnum,
    quotesCount: number,
}) {
    const navigate = useNavigate();

    async function switchForms(formTemplateTypeId: FormTemplateTypeEnum) {
        if (!params.formId) return;

        if (formTemplateTypeId !== FormTemplateTypeEnum.Mortgages) {
            try {
                const { id, token } = await formService.createByType(formTemplateTypeId, params.brand);
                navigate(withFormAccessToken(`/forms/${id}`, id, token));
            } catch (e) {
                handleErrorResponse(e);
            } finally {
                retryHeight(sendContainerHeightToParent);
            }
            return;
        }

        navigate(withFormAccessToken(`/forms/${params.formId}`, Number(params.formId)));
        retryHeight(sendContainerHeightToParent);
    }

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <ButtonGroup variant="outlined" fullWidth>
                    {quoteTypeOrder
                        .map((numericValue) => {
                            return (
                                <Button
                                    key={numericValue}
                                    onClick={() => switchForms(numericValue)}
                                    sx={{
                                        backgroundColor:
                                            numericValue === FormTemplateTypeEnum.Mortgages
                                                ? "primary.main"
                                                : "transparent",
                                        color:
                                            numericValue === FormTemplateTypeEnum.Mortgages
                                                ? "white"
                                                : "primary.main",
                                    }}
                                >
                                    {splitWordOnCamelCase(FormTemplateTypeEnum[numericValue])}
                                </Button>
                            );
                        })}
                </ButtonGroup>
            </Grid>

            <Grid item xs={12}>
                <Button
                    startIcon={<ArrowBack />}
                    size="small"
                    variant="contained"
                    color="secondary"
                    sx={{ width: { xs: "100% !important", md: "30% !important" } }}
                    onClick={() => navigate(withFormAccessToken(`/forms/${params.formId}`, Number(params.formId)))}
                >
                    <Typography variant="subtitle1">Change Quote Details</Typography>
                </Button>
            </Grid>

            <Grid item xs={12} mb={2}>
                <Typography variant="subtitle1" fontWeight="bold" textAlign="center">
                    {params.quotesCount} Mortgage quotes found for you
                </Typography>
            </Grid>
        </Grid>
    );
}
